// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section2 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section two' style={{colorScheme: this.props.colorMode === 'dark' ? 'dark' : 'light'}}>
      <div className="wrapper">
        <h2>Hier leben am meisten Hunde</h2>
            <div className='txt'>
              <p>
              Hunde sind in der ganzen Schweiz beliebt. Es gibt jedoch regionale Unterschiede. Berechnet man die Anzahl Tiere pro Einwohnerinnen und Einwohner, fällt auf, dass besonders Menschen in ländlichen Gemeinden viele Hunde haben. In der lateinischen Schweiz scheint das Haustier zudem noch ein wenig beliebter zu sein als in der Deutschschweiz. Als regelrechte Hunde-Hotspots entpuppen sich der Jura und das Tessin.
              </p>
            </div>
            <div className="chart big">
              <AutofitIFrame
                src={'https://datawrapper.dwcdn.net/HFtQQ/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
              />
            </div>

            <div className="chart">
              <AutofitIFrame
                src={'https://datawrapper.dwcdn.net/yiHQ0/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
              />
            </div>
      
          <div className='txt'>
            <p>
              Mit Abstand am meisten Tiere pro 100 Einwohner gibt es in Treytorrens im Kanton Waadt: Hier leben fast gleich viele Hunde wie Menschen. Bei den meisten handelt es sich um Tibet-Spaniel, denn in der Gemeinde gibt es eine Zucht dieser Rasse.
            </p>
            <p>
              Eine Hochburg ist auch Genf. Hier leben zwar nur 5 Hunde pro 100 Einwohner, aber dafür mehr als 10’000 Tiere auf sehr kleinem Raum. Fast 645 Hunde gibt es hier pro Quadratkilometer – deutlich mehr als in allen anderen Gemeinden.
            </p>
          </div>

      </div>
    </div>
  }
}
